import React from 'react'

export const PointsIcon: React.FC = () => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='5' r='2' fill='currentColor' />
    <circle cx='16' cy='16' r='2' fill='currentColor' />
    <circle cx='16' cy='27' r='2' fill='currentColor' />
  </svg>
)
